<template>
  <div class="container">
    <div class="row justify-content-center align-items-center" style="height:60vh">
      <div class="col-sm-4">
        <h3 class="text-center p-4">ログイン</h3>
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <input class="form-control" type="text" v-model="email" placeholder="email">
            </div>
            <div class="form-group">
              <input class="form-control" type="password" v-model="password" placeholder="password">
            </div>
            <button class="btn btn-outline-primary" @click="signIn">ログイン</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Signin',
  data () {
    return {
      email: '',
      password: '',
    }
  },
  methods: {
    signIn: function () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(() => {
        this.$router.push('/')
      })
      .catch((error) => {
        alert(error.message)
      })
    }
  }
}
</script>
